/**
 All of the routes for the Material Dashboard 2 PRO React are added here,
 You can add a new route, customize the routes and delete the routes here.

 Once you add a new route on this file it will be visible automatically on
 the Sidenav.

 For adding a new route you can follow the existing routes in the routes array.
 1. The `type` key with the `collapse` value is used for a route.
 2. The `type` key with the `title` value is used for a title inside the Sidenav.
 3. The `type` key with the `divider` value is used for a divider between Sidenav items.
 4. The `name` key is used for the name of the route on the Sidenav.
 5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
 6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
 7. The `collapse` key is used for making a collapsible item on the Sidenav that contains other routes
 inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
 8. The `route` key is used to store the route location which is used for the react router.
 9. The `href` key is used to store the external links location.
 10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
 10. The `component` key is used to store the component of its route.*/

import React from "react";

import Oficina from "./view/Oficina.js";
import Oficinas from "./view/Oficinas.js";
import Regiones from "./view/Regiones.js";
import Idiomas from "./view/Idiomas.js";
import Areas from "./view/Areas.js";
import Incidencias from "./view/Incidencias.js";
import ExtrasReservas from "./view/ExtrasReservas.js";
import TramosReserva from "./view/TramosReservas.js";
import InstalacionReservas from "./view/InstalacionReservas.js"
import Encuestas from "./view/Encuestas.js";
import EncuestasEstadistica from "./view/EncuestasEstadisticas.js";
import EncuestasEstadisticasFiltradas from "./view/EncuestasEstadisticasFiltradas.js";

import Pois from "./view/Pois.js";
import Usuarios from "./view/Usuarios.js";

import Dashboard from "./view/Dashboard.js";

import DashTienda from "./view/Tienda/DashTienda.js";
import Categorias from "./view/Tienda/Categorias.js";
import Marcas from "./view/Tienda/Marcas.js";
import Pedidos from "./view/Tienda/Pedidos.js";
import Articulos from "./view/Tienda/Articulos.js";

import Importacion from "./view/Importacion.js";
import  Perfil  from "./view/Perfil.js";
import LoginPage from "./view/LoginPage.jsx";
import LoginPageApps from "./view/LoginPageApps.jsx";
import LoginPageReservas from "./view/LoginPageReservas.jsx";
import { Roles, TipoOficina, OpcionSiNo } from "./othelloConstantes.jsx";
import Peticiones from "./view/Peticiones.js";
import ReservaFinPasarela from "./view/ReservaFinPasarela.js";
import CondicionesInfoPage from "./view/CondicionesInfoPage.js";

import Icon from "@mui/material/Icon";
import MDAvatar from "./components/MDAvatar";

import imageUsuario from "./assets/img/default-avatar.png";


export function getCurrentRouteSinUso(literal, nameUser) {
    return [
        {
            type: "collapse",
            name: nameUser,
            key: nameUser,
            icon: <MDAvatar src={imageUsuario} alt={nameUser} size="sm" />,
            collapse: [
                {
                    type: "estandar",
                    name: literal("_cerrasesion"),
                    key: "logout",
                    layout: "/auth",
                    route: "auth/login",
                }
            ]
        },
        { type: "divider", key: "divider-0" },
        {
            type: "estandar",
            path: "/dashboard",
            name: literal("_dashboard"),
            icon: <Icon fontSize="medium" >dashboard</Icon>,
            component: <Dashboard literal={literal} />,
            layout: "/admin",
            route: "/admin/dashboard",
            key: "dashboard",
            hideinsidebar: false
        },
        {
            type: "estandar",
            path: "/oficina",
            name: literal("_oficina"),
            icon: <Icon fontSize="medium" >business_center</Icon>,
            component: <Oficina literal={literal} />,
            layout: "/admin",
            route: "/admin/oficina",
            key: "oficina",
        },
        {
            type: "estandar",
            path: "/oficinas",
            name: literal("_misoficinas"),
            icon: <Icon fontSize="medium" >business_center</Icon>,
            component: <Oficinas literal={literal} />,
            layout: "/admin",
            route: "/admin/oficinas",
            key: "oficinas",
            hideinsidebar: true
        },
        {
            type: "estandar",
            path: "/idiomas",
            name: literal("_oficina"),
            icon: <Icon fontSize="medium" >language</Icon>,
            component: <Idiomas literal={literal} />,
            layout: "/admin",
            route: "/admin/idiomas",
            key: "idiomas",
        },
        {
            type: "estandar",
            path: "/regiones",
            name: literal("_regiones"),
            icon: <Icon fontSize="medium" >landscape</Icon>,
            component: <Regiones literal={literal} />,
            layout: "/admin",
            route: "/admin/regiones",
            key: "regiones",
        },
        {
            type: "estandar",
            path: "/areas",
            name: literal("_oficina"),
            icon: <Icon fontSize="medium" >nearme</Icon>,
            component: <Areas literal={literal} />,
            layout: "/admin",
            route: "/admin/areas",
            key: "areas",
        },
        {
            type: "estandar",
            path: "/pois",
            name: literal("_puntosinteres"),
            icon: <Icon fontSize="medium" >place</Icon>,
            component: <Pois literal={literal} />,
            layout: "/admin",
            route: "/admin/pois",
            key: "pois",
        },
        {
            type: "estandar",
            path: "/noticias",
            name: literal("_noticias"),
            icon: <Icon fontSize="medium" >language</Icon>,
            component: <Pois literal={literal} />,
            layout: "/admin",
            route: "/admin/noticias",
            key: "noticias",
            hideinsidebar: false
        },
        {
            type: "estandar",
            path: "/incidencias",
            name: literal("_incidencias"),
            icon: <Icon fontSize="medium" >howtovote</Icon>,
            component: <Incidencias literal={literal} />,
            layout: "/admin",
            route: "/admin/incidencias",
            key: "incidencias",
        },
        {
            type: "estandar",
            path: "/usuarios",
            name: literal("_usuarios"),
            icon: <Icon fontSize="medium" >group</Icon>,
            component: <Idiomas literal={literal} />,
            layout: "/admin",
            route: "/admin/usuarios",
            key: "usuarios",
        },
        //{
        //    path: "/archivos",
        //    name: "Archivos",
        //    rtlname: "",
        //    icon: SdStorage,
        //    component: Informes,
        //    layout: "/admin",
        //},
        {
            type: "estandar",
            path: "/profile",
            name: literal("_perfil"),
            icon: <Icon fontSize="medium" >person</Icon>,
            component: <Perfil literal={literal} />,
            layout: "/admin",
            route: "/admin/profile",
            key: "profile",
            hideinsidebar: true
        },
        {
            type: "estandar",
            path: "/dashboard",
            name: literal("_salir"),
            icon: <Icon fontSize="medium" >keyboard_return</Icon>,
            component: <Dashboard literal={literal} />,
            layout: "/admin",
            route: "/admin/dashboard",
            key: "dashboard"
        }
    ];
}

export function getCurrentRouteMain(literal, nameUser, idRol, idUser, areaAgenda, conincidencia, conareaprivada, loginmodoreserva, loginapps, tipooficina, gestionreservas, gestionencuestas)
{
    var dashRoutes = [];
   
    //Si esto en modo usuario normal
    if (idRol != Roles.UsuarioApp && !loginmodoreserva && !loginapps)
    {
        dashRoutes.push({
            type: "collapse",
            name: nameUser,
            key: nameUser,
            icon: <MDAvatar src={imageUsuario} alt={nameUser} size="sm" />,
            collapse: [
                {
                    type: "estandar",
                    path: "/profile",
                    name: literal("_perfil"),
                    icon: <Icon fontSize="medium" >person</Icon>,
                    component: <Perfil literal={literal} idRol={idRol} idUser={idUser} loginmodoreserva={loginmodoreserva} loginapps={loginapps} tipooficina={tipooficina}  />,
                    layout: "/admin",
                    route: "/admin/profile",
                    key: "profile"                                      
                },
                {
                    type: "estandar",
                    path: "/importacion",
                    name: literal("_importacion"),
                    icon: <Icon fontSize="medium" >person</Icon>,
                    component: <Importacion literal={literal} idRol={idRol} idUser={idUser} loginmodoreserva={loginmodoreserva} loginapps={loginapps} tipooficina={tipooficina}  />,
                    layout: "/admin",
                    route: "/admin/importacion",
                    key: "importacion",                    
                },
                {
                    type: "estandar",
                    name: literal("_cerrasesion"),
                    key: "login",
                    layout: "/auth",
                    route: "auth/login",
                }
            ]
        });        
    }
    //sino, es que es de tipo usuario de app
    else
    {


        //SI estamos en modo login del modulo de reservas
        if (loginmodoreserva)
        {
            dashRoutes.push({
                type: "collapse",
                name: nameUser,
                key: nameUser,
                icon: <MDAvatar src={imageUsuario} alt={nameUser} size="sm" />,
                collapse: [
                    {
                        type: "estandar",
                        path: "/profile",
                        name: literal("_perfil"),
                        icon: <Icon fontSize="medium" >person</Icon>,
                        component: <Perfil literal={literal} idRol={idRol} idUser={idUser} loginmodoreserva={loginmodoreserva} loginapps={loginapps} tipooficina={tipooficina} />,
                        layout: "/admin",
                        route: "/admin/profile",
                        key: "profile"
                    },
                    {
                        type: "estandar",
                        name: literal("_cerrasesion"),
                        key: "loginreservas",
                        layout: "/authapps",
                        route: "authapps/loginreservas",
                    }
                ]
            });          
        }
        else {

            dashRoutes.push({
                type: "collapse",
                name: nameUser,
                key: nameUser,
                icon: <MDAvatar src={imageUsuario} alt={nameUser} size="sm" />,
                collapse: [
                    {
                        type: "estandar",
                        path: "/profile",
                        name: literal("_perfil"),
                        icon: <Icon fontSize="medium" >person</Icon>,
                        component: <Perfil literal={literal} idRol={idRol} idUser={idUser} loginmodoreserva={loginmodoreserva} loginapps={loginapps} tipooficina={tipooficina} />,
                        layout: "/admin",
                        route: "/admin/profile",
                        key: "profile"
                    },
                    {
                        type: "estandar",
                        name: literal("_cerrasesion"),
                        key: "loginapp",
                        layout: "/authapps",
                        route: "auth/loginapp",
                    }
                ]
            });
        }
    }

    dashRoutes.push({ type: "divider", key: "divider-0" });


    if (idRol != Roles.UsuarioApp && !loginmodoreserva && !loginapps)
    {
        dashRoutes.push(
            {
                type: "estandar",
                path: "/dashboard",
                name: literal("_dashboard"),
                icon: <Icon fontSize="medium" >dashboard</Icon>,
                component: <Dashboard literal={literal} idRol={idRol} idUser={idUser} loginmodoreserva={loginmodoreserva} loginapps={loginapps} tipooficina={tipooficina}   />,
                layout: "/admin",
                route: "/admin/dashboard",
                key: "dashboard",
                hideinsidebar: false
            });

        dashRoutes.push({
            type: "estandar",
            path: "/oficinas",
            name: literal("_misoficinas"),
            icon: <Icon fontSize="medium" >business_center</Icon>,
            component: <Oficinas literal={literal} idRol={idRol} idUser={idUser} loginmodoreserva={loginmodoreserva} loginapps={loginapps} tipooficina={tipooficina}  />,
            layout: "/admin",
            route: "/admin/oficinas",
            key: "oficinas",           
            hideinsidebar: true,            
        });
    }
         
    dashRoutes.push({
        type: "estandar",
        path: "/finreserva",
        name: literal("_reserva"),
        icon: <Icon fontSize="medium" >person</Icon>,
        component: <ReservaFinPasarela literal={literal} idRol={idRol} idUser={idUser} loginmodoreserva={loginmodoreserva} loginapps={loginapps} tipooficina={tipooficina}  />,
        layout: "/admin",
        route: "/admin/finreserva",
        key: "finreserva",               
        hideinsidebar: true,        
    });

    dashRoutes.push({
        type: "estandar",
        path: "/condiciones",
        name: literal("_dashboard"),
        icon: <Icon fontSize="medium" >dashboard</Icon>,
        component: <CondicionesInfoPage literal={literal} idRol={idRol} idUser={idUser} loginmodoreserva={loginmodoreserva} loginapps={loginapps} tipooficina={tipooficina}  />,
        layout: "/admin",
        route: "/admin/condiciones",
        key: "condiciones",              
        hideinsidebar: true       
    });

    if (idRol == Roles.SuperUsuario && !loginmodoreserva && !loginapps)
    {       
        dashRoutes.push({
            type: "estandar",
            path: "/oficina",
            name: literal(tipooficina != null && tipooficina == 3 ? "_plataforma" : "_oficina"),
            icon: <Icon fontSize="medium" >business_center</Icon>,
            component: <Oficina literal={literal} idRol={idRol} idUser={idUser} loginmodoreserva={loginmodoreserva} loginapps={loginapps} tipooficina={tipooficina} />,
            layout: "/admin",
            route: "/admin/oficina",
            key: "oficina"            
        });

        dashRoutes.push({
            type: "estandar",
            path: "/idiomas",
            name: literal("_idiomas"),
            icon: <Icon fontSize="medium" >language</Icon>,
            component: <Idiomas literal={literal} idRol={idRol} idUser={idUser} loginmodoreserva={loginmodoreserva} loginapps={loginapps} tipooficina={tipooficina}  />,
            layout: "/admin",
            route: "/admin/idiomas",
            key: "idiomas"                      
        });

        dashRoutes.push({
            type: "estandar",
            path: "/regiones",
            name: literal(tipooficina != null && tipooficina == 3 ? "_segmentos" : "_regiones"),
            icon: <Icon fontSize="medium" >landscape</Icon>,
            component: <Regiones literal={literal} idRol={idRol} idUser={idUser} loginmodoreserva={loginmodoreserva} loginapps={loginapps} tipooficina={tipooficina}   />,
            layout: "/admin",
            route: "/admin/regiones",
            key: "regiones"         
        });

        dashRoutes.push({
            type: "estandar",
            path: "/areas",
            name: literal("_areas"),
            icon: <Icon fontSize="medium" >near_me</Icon>,
            component: <Areas literal={literal} idRol={idRol} idUser={idUser} loginmodoreserva={loginmodoreserva} loginapps={loginapps} tipooficina={tipooficina}  />,
            layout: "/admin",
            route: "/admin/areas",
            key: "areas"         
        });
    }

    if (idRol != Roles.UsuarioApp && !loginmodoreserva && !loginapps) {
        dashRoutes.push({
            type: "estandar",
            path: "/pois",
            name: literal(tipooficina != null && tipooficina == 3 ? "_establecimientos" : "_puntosdeinteres"),
            icon: <Icon fontSize="medium" >place</Icon>,
            component: <Pois literal={literal} idRol={idRol} idUser={idUser} loginmodoreserva={loginmodoreserva} loginapps={loginapps} tipooficina={tipooficina}  />,
            layout: "/admin",
            route: "/admin/pois",
            key: "pois"                     
        });
    }

    if (idRol != Roles.UsuarioApp && areaAgenda != null && areaAgenda != "" && !loginmodoreserva && !loginapps) 
    {
        dashRoutes.push({
            type: "estandar",
            path: "/noticias",
            name: areaAgenda,
            icon: <Icon fontSize="medium" >forum</Icon>,
            component: <Pois literal={literal} idRol={idRol} idUser={idUser} loginmodoreserva={loginmodoreserva} loginapps={loginapps} tipooficina={tipooficina}  />,
            layout: "/admin",
            route: "/admin/noticias",
            key: "noticias",           
            hideinsidebar: false           
        });
    }

    if ((idRol == Roles.SuperUsuario || idRol == Roles.Administrador) && conincidencia && !loginmodoreserva && !loginapps) {

        dashRoutes.push({
            type: "estandar",
            path: "/incidencias",
            name: literal("_incidencias"),
            icon: <Icon fontSize="medium" >how_to_vote</Icon>,
            component: <Incidencias literal={literal} idRol={idRol} idUser={idUser} loginmodoreserva={loginmodoreserva} loginapps={loginapps} tipooficina={tipooficina}   />,
            layout: "/admin",
            route: "/admin/incidencias",
            key: "incidencias"           
        });
    }

    if (((idRol == Roles.SuperUsuario || idRol == Roles.Administrador) /*&& tipooficina == TipoOficina.Venta*/) && !loginmodoreserva && !loginapps) {

        dashRoutes.push({
            type: "estandar",
            path: "/peticiones",
            name: literal("_peticiones"),
            icon: <Icon fontSize="medium" >import_contacts</Icon>,
            component: <Peticiones literal={literal} idRol={idRol} idUser={idUser} loginmodoreserva={loginmodoreserva} loginapps={loginapps} tipooficina={tipooficina}  />,
            layout: "/admin",
            route: "/admin/peticiones",
            key: "peticiones",
            layout: "/admin"            
        });
    }

    if ((idRol == Roles.SuperUsuario || gestionreservas == 1) /*|| idRol == Roles.Administrador*/ && !loginmodoreserva && !loginapps)
    {
        dashRoutes.push(
            {
                type: "collapse",
                name: "Reservas",
                key: "reservas",
                icon: <Icon fontSize="medium" >book</Icon>,
                collapse: [
                    {
                        type: "estandar",
                        path: "/instalaciones",
                        name: literal("_instalaciones"),
                        icon: <Icon fontSize="medium" >storemalldirectory</Icon>,
                        component: <InstalacionReservas literal={literal} idRol={idRol} idUser={idUser} loginmodoreserva={loginmodoreserva} loginapps={loginapps} tipooficina={tipooficina}  />,
                        layout: "/admin",
                        route: "/admin/instalaciones",
                        key: "instalaciones"                        
                    },
                    {
                        type: "estandar",
                        path: "/tramos",
                        name: literal("_tramos"),
                        icon: <Icon fontSize="medium" >dns</Icon>,
                        component: <TramosReserva literal={literal} idRol={idRol} idUser={idUser} loginmodoreserva={loginmodoreserva} loginapps={loginapps} tipooficina={tipooficina}  />,
                        layout: "/admin",
                        route: "/admin/tramos",
                        key: "tramos"                        
                    },
                    {
                        type: "estandar",
                        path: "/extras",
                        name: literal("_extras"),
                        icon: <Icon fontSize="medium" >extension</Icon>,
                        component: <ExtrasReservas literal={literal} idRol={idRol} idUser={idUser} loginmodoreserva={loginmodoreserva} loginapps={loginapps} tipooficina={tipooficina} />,
                        layout: "/admin",
                        route: "/admin/extras",
                        key: "extras"
                    },
                ],
            });
    }

    if ((idRol == Roles.SuperUsuario || gestionencuestas == 1) /*|| idRol == Roles.Administrador*/ && !loginmodoreserva && !loginapps) {


        dashRoutes.push(
            {
                type: "collapse",
                name: "Encuestas",
                key: "encuestas",
                icon: <Icon fontSize="medium" >article</Icon>,
                collapse: [
                    {
                        type: "estandar",
                        path: "/definicion",
                        name: literal("_encuestas"),
                        icon: <Icon fontSize="medium" >assignment</Icon>,
                        component: <Encuestas literal={literal} idRol={idRol} idUser={idUser} loginmodoreserva={loginmodoreserva} loginapps={loginapps} tipooficina={tipooficina}  />,
                        layout: "/admin",
                        route: "/admin/definicion",
                        key: "definicion"                      
                    },
                    {
                        type: "estandar",
                        path: "/estadisticas",
                        name: literal("_estadisticas"),
                        icon: <Icon fontSize="medium" >equalizer</Icon>,
                        component: <EncuestasEstadistica literal={literal} idRol={idRol} idUser={idUser} loginmodoreserva={loginmodoreserva} loginapps={loginapps} tipooficina={tipooficina}   />,
                        layout: "/admin",
                        route: "/admin/estadisticas",
                        key: "estadisticas"                        
                    },
                    {
                        type: "estandar",
                        path: "/filtrosstats",
                        name: literal("_estadisticasfiltradas"),
                        icon: <Icon fontSize="medium" >equalizer</Icon>,
                        component: <EncuestasEstadisticasFiltradas literal={literal} idRol={idRol} idUser={idUser} loginmodoreserva={loginmodoreserva} loginapps={loginapps} tipooficina={tipooficina}   />,
                        layout: "/admin",
                        route: "/admin/filtrosstats",
                        key: "filtrosstats",                        
                    }
                ],
            });
    }

    if ((idRol == Roles.SuperUsuario || (idRol == Roles.Administrador && conareaprivada)) && !loginmodoreserva && !loginapps) {
        dashRoutes.push(
            {
                type: "estandar",
                path: "/usuarios",
                name: literal("_usuarios"),
                icon: <Icon fontSize="medium" >group</Icon>,
                component: <Usuarios literal={literal} idRol={idRol} idUser={idUser} loginmodoreserva={loginmodoreserva} loginapps={loginapps} tipooficina={tipooficina}  />,
                layout: "/admin",
                route: "/admin/usuarios",
                key: "usuarios"                
            });
    }

    return dashRoutes;
}

export function getRoutesTienda(literal, nameUser, idRol, idUser, areaAgenda, conincidencia, conareaprivada, loginmodoreserva, loginapps, tipooficina, idpoitienda)
{
    var dashRoutes = [];

    dashRoutes.push(
        {
            type: "estandar",
            path: "/dashtienda",
            name: literal("_dashboard"),
            icon: <Icon fontSize="medium" >dashboard</Icon>,
            component: <DashTienda literal={literal} idRol={idRol} idUser={idUser} loginmodoreserva={loginmodoreserva} loginapps={loginapps} tipooficina={tipooficina} idpoitienda={idpoitienda} />,
            layout: "/admin",
            route: "/admin/dashtienda",
            key: "dashtienda",
            hideinsidebar: false
        });

    dashRoutes.push(
        {
            type: "estandar",
            path: "/tienda/categorias",
            name: literal("_categorias"),
            icon: <Icon fontSize="medium" >view_module</Icon>,
            component: <Categorias literal={literal} idRol={idRol} idUser={idUser} loginmodoreserva={loginmodoreserva} loginapps={loginapps} tipooficina={tipooficina} idpoitienda={idpoitienda} />,
            layout: "/admin",
            route: "/admin/tienda/categorias",
            key: "categorias",
            hideinsidebar: false
        });
    dashRoutes.push(
        {
            type: "estandar",
            path: "/tienda/marcas",
            name: literal("_marcas"),
            icon: <Icon fontSize="medium" >local_mall</Icon>,
            component: <Marcas literal={literal} idRol={idRol} idUser={idUser} loginmodoreserva={loginmodoreserva} loginapps={loginapps} tipooficina={tipooficina} idpoitienda={idpoitienda} />,
            layout: "/admin",
            route: "/admin/tienda/marcas",
            key: "marcas",
            hideinsidebar: false
        });
    dashRoutes.push(
        {
            type: "estandar",
            path: "/tienda/articulos",
            name: literal("_articulos"),
            icon: <Icon fontSize="medium" >local_grocery_store</Icon>,
            component: <Articulos literal={literal} idRol={idRol} idUser={idUser} loginmodoreserva={loginmodoreserva} loginapps={loginapps} tipooficina={tipooficina} idpoitienda={idpoitienda} />,
            layout: "/admin",
            route: "/admin/tienda/articulos",
            key: "articulos",
            hideinsidebar: false
        });

    dashRoutes.push(
        {
            type: "estandar",
            path: "/tienda/pedidos",
            name: literal("_pedidos"),
            icon: <Icon fontSize="medium" >receipt</Icon>,
            component: <Pedidos literal={literal} idRol={idRol} idUser={idUser} loginmodoreserva={loginmodoreserva} loginapps={loginapps} tipooficina={tipooficina} idpoitienda={idpoitienda} />,
            layout: "/admin",
            route: "/admin/tienda/pedidos",
            key: "pedidos",
            hideinsidebar: false
        });

    dashRoutes.push({
        type: "estandar",
        path: "/pois",
        name: literal("_salir"),
        icon: <Icon fontSize="medium" >keyboard_return</Icon>,
        component: <Pois literal={literal} idRol={idRol} idUser={idUser} loginmodoreserva={loginmodoreserva} loginapps={loginapps} tipooficina={tipooficina} />,
        layout: "/admin",
        route: "/admin/pois",
        key: "pois"
    });


    return dashRoutes;
}